module.exports = __webpack_public_path__ + "static/media/coins.7d7cba58.gif";